module.exports = __webpack_public_path__ + "img/E.3b0137a7.png";